import React, { useMemo } from 'react';
import { WallPlannerTeamRow } from "./WallPlannerTeamRow";
import { WallPlannerUserRow } from "./WallPlannerUserRow";
import { WallPlannerEditWeekRow } from "./WallPlannerEditWeekRow";
import styled from "styled-components";
import { WallPlannerProjectRow } from "./WallPlannerProjectRow";
import { useSelector } from "react-redux";
import { selectTeamDetails } from "../wallPlanner.duck";
import { Moment } from "moment";
import { GroupWallPlannerWhereabouts } from '@features/wall-planner/wall-planner.models';

interface Props {
  team?: { id: string, name: string };
  isFirst: boolean;
  weeksInMonth: Moment[];
}

export function WallPlannerTeamPlan(props: Props) {
  const {weeksInMonth, isFirst, team} = props;
  const allTeamDetails = useSelector(selectTeamDetails);
  const teamDetails: GroupWallPlannerWhereabouts = useMemo(() => {
    if (team) {
      const details = allTeamDetails[team.id];
      return {
        whereabouts: details?.whereabouts ?? [],
        restricted: details?.restricted,
      }
    } else {
      return {whereabouts: []};
    }
  }, [team, allTeamDetails]);

  if (team) {
    return (
      <TeamContainer columns={weeksInMonth.length + (window.innerWidth < 768 ? 0 : 1)}>

        <WallPlannerTeamRow isFirst={isFirst} teamName={team.name} restricted={teamDetails?.restricted}/>

        {!teamDetails?.restricted && <>
          <WallPlannerProjectRow team={team}/>
          {teamDetails.whereabouts.map((user: any, k: any) => (
            <React.Fragment key={k}>
              <WallPlannerUserRow position={k} user={user.userInfo} working={user.working} holidays={user.holidays} schengenUsage={user.schengenUsage}/>
              <WallPlannerEditWeekRow userId={user.userInfo.userId}/>
            </React.Fragment>
          ))}

          <WallPlannerUserRow id={'workPlannerRow'} />
        </>}
      </TeamContainer>
    )
  } else {
    return null;
  }

}

const TeamContainer = styled.div<any>`
  width: 100%;
  height: 100%;
  &:last-child {
    margin-bottom: 55px;
  }
  .userColumn__wrapper {
    //z-index: 999;
  }
`
